/*********************************************************************************************
* Active container
    *
*/
document.addEventListener("DOMContentLoaded", function() {
    // Sélection de tous les éléments de filtre et de contenu
    const filters = document.querySelectorAll(".mm-page-faq-filter");
    const faqContents = document.querySelectorAll(".mm-page-faq-filter-content-container");

    // Vérification qu'il y a au moins un élément dans chaque liste
    if (filters.length > 0 && faqContents.length > 0) {
        // Activation par défaut du premier filtre et du premier contenu
        filters[0].classList.add("active");
        faqContents[0].classList.add("active");
    }

    // Fonction pour activer le filtre et la section associée au clic
    filters.forEach((filter, index) => {
        filter.addEventListener("click", function() {
            // Suppression de la classe 'active' de tous les filtres et sections de contenu
            filters.forEach(f => f.classList.remove("active"));
            faqContents.forEach(content => content.classList.remove("active"));

            // Activation du filtre et de la section de contenu correspondants
            filter.classList.add("active");
            faqContents[index].classList.add("active");
        });
    });
});

/*********************************************************************************************
* Splide tabs
    *
*/
document.addEventListener('DOMContentLoaded', function() {
    var splideSections = document.querySelectorAll('[data-section-page-faq-id]');
    
    splideSections.forEach(function(section) {
        var splideElem = section.querySelector('.splide-faq-tabs');
        
        if (splideElem) {
            new Splide(splideElem, {
                type: 'slide',
                arrows: false,
                pagination: false,
                perPage: 1,
                drag: 'free',
                snap: true,    
                gap: '6px',
                speed: 500, 
                destroy: true,
                breakpoints: {
                    768: {
                        destroy: false,
                    }
                }
            }).mount();
        }
    });
});